import { Component, Input, OnInit } from '@angular/core';
import { Block, BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { BlockTimelineChartComponent } from '@core-app/blocks/block-leave-of-absence-tool/results/timeline-chart/block-timeline-chart.component';
import { TranslatePipe } from '@gallaghercp/core-frontend-contracts';

@Component({
    selector: 'core-bonding-results',
    templateUrl: './block-bonding-results.component.html',
    styleUrls: [
        '../../scss/block-leave-of-absence-tool-charts.scss',
        '../../scss/block-leave-of-absence-tool-questions.scss',
        '../../scss/block-leave-of-absence-tool-timeline.scss',
    ],
    imports: [BlockTimelineChartComponent, TranslatePipe],
})
export class BlockBondingResultsComponent extends BlockAbstractComponent implements OnInit {
    @Input() selectedAnswers: Record<string, any> = {};
    @Input() bondingTimelineChartKey: string = '';
    @Input() parentBlock: Block | undefined;

    // Section text strings
    introParagraphText!: string;
    lengthOfLeaveText!: string;
    payText!: string;
    processChecklist!: string;
    thingsToConsider!: string;

    override ngOnInit() {
        // Create a mapping of conditions to their corresponding intro paragraph text
        const introParagraphMapping = [
            {
                condition: this.bondingOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.bondingIntroParagraphLeaveQualified,
            },
            {
                condition: this.bondingOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.bondingIntroParagraphLeaveQualified,
            },
            {
                condition: this.bondingOnlyNinetyDaysOrLess,
                text: this.parentBlock?.data.bondingIntroParagraphLeaveNotQualifiedUseWellnessDays,
            },
        ];

        // Create a mapping of conditions to their corresponding length of leave text
        const lengthOfLeaveMapping = [
            {
                condition: this.bondingOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.bondingLengthOfLeaveUpToTwelveWeeks,
            },
            {
                condition: this.bondingOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.bondingLengthOfLeaveUpToSixWeeks,
            },
        ];

        // Create a mapping of conditions to their corresponding pay text
        const payMapping = [
            {
                condition: this.bondingOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.bondingPayFirstSixWeeksAtOneHundredPercentRemainingTimeUnpaid,
            },
            {
                condition: this.bondingOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.bondingPayFirstSixWeeksAtOneHundredPercentRemainingPersonalLeaveRequest,
            },
        ];

        // Create a mapping of conditions to their corresponding process list text
        const processListMapping = [
            {
                condition: this.bondingOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.bondingProcessList,
            },
            {
                condition: this.bondingOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.bondingProcessList,
            },
        ];

        // Create a mapping of conditions to their corresponding things to consider text
        const thingsToConsiderMapping = [
            {
                condition: this.bondingOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.bondingThingsToConsiderOne,
            },
            {
                condition: this.bondingOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.bondingThingsToConsiderOne,
            },
            {
                condition: this.bondingOnlyNinetyDaysOrLess,
                text: this.parentBlock?.data.bondingThingsToConsiderTwo,
            },
        ];

        // Find the first matching condition and set the intro paragraph text
        const introParagraphMatch = introParagraphMapping.find(item => item.condition);
        if (introParagraphMatch) {
            this.introParagraphText = introParagraphMatch.text;
        }

        // Find the first matching condition and set the length of leave text
        const lengthOfLeaveMatch = lengthOfLeaveMapping.find(item => item.condition);
        if (lengthOfLeaveMatch) {
            this.lengthOfLeaveText = lengthOfLeaveMatch.text;
        }

        // Find the first matching condition and set the pay text
        const payMatch = payMapping.find(item => item.condition);
        if (payMatch) {
            this.payText = payMatch.text;
        }

        // Find the first matching condition and set the process list text
        const processListMatch = processListMapping.find(item => item.condition);
        if (processListMatch) {
            this.processChecklist = processListMatch.text;
        }

        // Find the first matching condition and set the things to consider text
        const thingsToConsiderMatch = thingsToConsiderMapping.find(item => item.condition);
        if (thingsToConsiderMatch) {
            this.thingsToConsider = thingsToConsiderMatch.text;
        }
        super.ngOnInit();
    }

    get bondingOnlyTwelveMonthsOrMore(): boolean {
        return this.selectedAnswers['employedDuration'] == 'twelveMonthsOrMore';
    }

    get bondingOnlyLessThanTwelveMonthsButMoreThanNinetyDays(): boolean {
        return this.selectedAnswers['employedDuration'] == 'lessThanTwelveMonthsButMoreThanNinetyDays';
    }

    get bondingOnlyNinetyDaysOrLess(): boolean {
        return this.selectedAnswers['employedDuration'] == 'ninetyDaysOrLess';
    }
}
